import { render } from "./view-client.vue?vue&type=template&id=2d2f556e&lang=html"
import script from "./view-client.vue?vue&type=script&lang=js"
export * from "./view-client.vue?vue&type=script&lang=js"

import "./view-client.vue?vue&type=style&index=0&id=2d2f556e&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__